import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandModelService } from 'app/services/models/brand-model.service';
import { BrandService } from 'app/services/models/brand.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-brand-model',
  templateUrl: './create-brand-model.component.html',
  styleUrls: ['./create-brand-model.component.scss']
})
export class CreateBrandModelComponent implements OnInit {

  brandModelForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private brandService: BrandService,
    private brandModelSerivce: BrandModelService,
    private toastSerivce: ToastrService,
    ) { }

  async ngOnInit() {
    this.brandModelForm = this.fb.group({
      brandId: [null],
      brandModelName: [null, [Validators.required]]
    });
    await this.getAllBrand();
  }
  brands: any[];

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    this.brands = data;
    console.log(this.brands);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.brandModelForm.valid) {
      console.log(this.brandModelForm.value);
      if (this.brandModelForm.value.brandId) {
        const response = await this.brandModelSerivce.createBrandModels(this.brandModelForm.value.brandModelName, this.brandModelForm.value.brandId);
        if (response.status) {
          this.brandService.sendEvent(true);
          this.toastSerivce.success(response.message);
          this.closeModal();
        } else {
          this.toastSerivce.error(response.message);
        }
      }else{
        const response = await this.brandService.createBrand(this.brandModelForm.value.brandModelName);
        if (response.status) {
          this.brandService.sendEvent(true);
          this.toastSerivce.success(response.message);
          await this.getAllBrand();
          this.brandModelForm.reset();
        } else {
          this.toastSerivce.error(response.message);
        }
      }
    }
  }
}